import { auth } from 'api-client';

import PaltaCombo from '@palta-ui/combo';

export default {
  extends: PaltaCombo,
  props: {
    labelKey: {
      default: 'name',
    },
  },
  data() {
    return {
      url: 'countries',
      model: 'countries',
      api: auth,
      itemOptions: {
        itemValueKey: 'name',
      },
    };
  },
};
